module.exports = __webpack_public_path__ + "img/tela-faelplus.4ac856e4.png";